import { render, staticRenderFns } from "./MenuImg.vue?vue&type=template&id=6a7c5124&scoped=true&lang=pug&"
import script from "./MenuImg.vue?vue&type=script&lang=ts&"
export * from "./MenuImg.vue?vue&type=script&lang=ts&"
import style0 from "./MenuImg.vue?vue&type=style&index=0&id=6a7c5124&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7c5124",
  null
  
)

export default component.exports